import React from 'react';

/**
 * Color variants for active state indicators
 */
const COLORS = {
  purple: 'bg-purple-900/20 border-purple-700 text-purple-300',
  green: 'bg-green-900/20 border-green-700 text-green-300',
  orange: 'bg-orange-900/20 border-orange-700 text-orange-300',
  yellow: 'bg-yellow-900/20 border-yellow-700 text-yellow-300',
  red: 'bg-red-900/20 border-red-700 text-red-300',
  blue: 'bg-blue-900/20 border-blue-700 text-blue-300',
};

/**
 * ActiveStateIndicator - Shows active effect status
 *
 * @param {string} message - Message to display
 * @param {string} variant - Color variant (purple, green, orange, yellow, red, blue)
 * @param {string} icon - Optional icon to prepend to message
 * @param {string} className - Additional CSS classes
 */
const ActiveStateIndicator = ({
  message,
  variant = 'purple',
  icon,
  className = '',
}) => {
  const colorClasses = COLORS[variant] || COLORS.purple;

  return (
    <div className={`mt-2 p-2 rounded border ${colorClasses} ${className}`}>
      <p className="text-xs">
        {icon && <span className="mr-1">{icon}</span>}
        {message}
      </p>
    </div>
  );
};

/**
 * TokenCounter - Shows token count (current/max)
 */
export const TokenCounter = ({
  current,
  maximum,
  label,
  variant = 'purple',
  className = '',
}) => {
  const colorClasses = COLORS[variant] || COLORS.purple;
  const isEmpty = current <= 0;

  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs ${colorClasses} ${isEmpty ? 'opacity-50' : ''} ${className}`}>
      {label && <span>{label}:</span>}
      <span className="font-bold">{current}/{maximum}</span>
    </div>
  );
};

export default ActiveStateIndicator;
